<div class="input">
  <span class="input-name" *ngIf="name && name != ''">{{ name }}</span>
  <div [ngClass]="dateTime.invalid ? 'd-flex invalid-input-box' : 'd-flex input-box'">
    <div class="input-non-ranged">
      <img
        *ngIf="withImage"
        src="../../../../assets/icons/Calendar.svg"
        class="input-image-calender"
        [owlDateTimeTrigger]="dt1"
      />
      <input
        [owlDateTime]="dt1"
        spellcheck="false"
        [ngModel]="owlMoment"
        placeholder="{{ placeholder }}"
        [selectMode]="'single'"
        [ngClass]="[dateTime.invalid || invalid ? 'invalid-input-date' : 'input-date']"
        [class.required]="!semiRequired && showRequired"
        [class.semi-required]="showSemiRequired"
        [class.recommended]="recommended"
        [class.input-non-ranged-highlight-border]="highlightBorderOnInputNonEmpty && !!owlMoment && !!dateTime && !dateTime.invalid && !invalid && !disabled"
        [disabled]="disabled"
        [min]="minMoment"
        [max]="maxMoment"
        (dateTimeChange)="onPickerDateChange($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur()"
        #inputfield
        #dateTime="ngModel"
      />
      <owl-date-time
        [disabled]="disabled"
        [pickerType]="'calendar'"
        #dt1
        [firstDayOfWeek]="1"
        [startAt]="startAt"
      ></owl-date-time>
    </div>
  </div>
</div>
